const tabNames = ['balances', 'positions', 'orders', 'conditionalOrders'] as const;

export { tabNames };
